export default __webpack_public_path__ + "static/media/fedex-logo.74d00f5c.svg";